export default "__VITE_ASSET__CrjGpOjI__"